import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  "aria-label"?: string;
}

const SearchIcon: FunctionComponent<Props> = ({
  className,
  width = 25,
  height = 24,
  fill = "currentColor",
  stroke = "currentColor",
  strokeWidth = ".5",
  "aria-label": ariaLabel,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9014 19.5858C17.0158 21.0382 14.6241 21.9067 12.0217 21.9067C5.9346 21.9067 1 17.1549 1 11.2932C1 5.43152 5.9346 0.679688 12.0217 0.679688C18.1089 0.679688 23.0435 5.43152 23.0435 11.2932C23.0435 13.7992 22.1416 16.1023 20.6333 17.918L26 23.086L24.2681 24.7538L18.9014 19.5858ZM3.44927 11.2932C3.44927 6.73412 7.2873 3.03825 12.0217 3.03825C16.7562 3.03825 20.5942 6.73412 20.5942 11.2932C20.5942 13.416 19.7621 15.3516 18.3949 16.8142L17.755 17.4303C16.2362 18.7469 14.2262 19.5482 12.0217 19.5482C7.2873 19.5482 3.44927 15.8523 3.44927 11.2932Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
    />
  </svg>
);

export default SearchIcon;
